import React from "react";
import Product from "../component/Product";
import AmazonBackground from "../images/amazonbk.jpg";
import theLeanStartup from "../images/the lean startup.jpg";
import iphone from "../images/iphone.webp";
import jacket from "../images/jacket.jpg";
import mic from "../images/mic.jpg";
import tv from "../images/tv.jpg";
import band from "../images/band.jpg";

import "../styles/Home.css";
import { Link } from "react-router-dom";

function Home() {
  return (
    <div className="home">
      <div className="home__container">
        <img
          className="home__image"
          src={AmazonBackground}
          alt="AmazonBackground"
        />

        <div className="home-row">
          <Product
            id={1}
            title="A rosy hue and peplum sweeten the cool-girl look of a faux-leather moto jacket finished with quilted detailing and shining hardware."
            price={29.99}
            image={jacket}
            rating={5}
          />

          <Product
            id={2}
            title="AstroAI Digital Tire Pressure Gauge with AAA Battery, 150 PSI 4 Settings Car Truck Bicycle Backlit LCD Non-Slip Grip, Gray "
            price={11.99}
            image={theLeanStartup}
            rating={5}
          />
        </div>

        <div className="home-row">
          <Product
            id={3}
            title="Blue Yeti USB Mic for Recording & Streaming on PC and Mac, 3 Condenser Capsules, 4 Pickup Patterns, Headphone Output and Volume Control, Mic Gain Control, Adjustable Stand, Plug & Play – Blackout "
            price={1000}
            image={mic}
            rating={5}
          />

          <Product
            id={4}
            title="New Apple iPhone 12 Pro Max (128GB, Graphite) [Locked] + Carrier Subscription"
            price={1000}
            image={iphone}
            rating={5}
          />
          <Product
            id={5}
            title="LETSCOM Fitness Tracker HR, Activity Tracker Watch with Heart Rate Monitor, Waterproof Smart Fitness Band with Step Counter, Calorie Counter, Pedometer Watch for Women and Men"
            price={27.98}
            image={band}
            rating={5}
          />
        </div>

        <div className="home-row">
          <Product
            id={6}
            title="TCL 32-inch 3-Series 720p Roku Smart TV - 32S335, 2021 Model "
            price={150}
            image={tv}
            rating={3}
          />
        </div>
      </div>
    </div>
  );
}

export default Home;
